import axios from "axios"
let env = process.env.NODE_ENV;

export const VUE_APP_WX_SIGNATURE_URL =
    env === "production"
        ? "https://wapapi.nfapp.southcn.com/nfplus-wap-api/wx/getShareSignInfo"
        : env === "test"
            ? "https://testwapapi.nfapp.southcn.com/nfplus-wap-api/wx/getShareSignInfo"
            : "https://testwapapi.nfapp.southcn.com/nfplus-wap-api/wx/getShareSignInfo";

const BASE_API =
    env === "production"
        ? "https://hd2.nfapp.southcn.com/nfplus-congress-sign"
        : env === "test"
            ? "https://testhd.nfapp.southcn.com/nfplus-congress-sign"
            : "https://testhd.nfapp.southcn.com/nfplus-congress-sign"

export const ARTICLE_API =
    env === "production"
        // ? "https://api.nfapp.southcn.com/nfplus-manuscript-web"
        ? "https://hd2.nfapp.southcn.com/nfplus-manuscript-web"
        : env === "test"
            ? "https://testapi.nfapp.southcn.com/nfplus-manuscript-web"
            // ? "https://testapi.nfapp.southcn.com/nfplus-manuscript-web"
            : "https://testapi.nfapp.southcn.com/nfplus-manuscript-web"
export const ARTICLE_API2 =
    env === "production"
        // ? "https://api.nfapp.southcn.com/nanfang_if/getColumns"
        ? "https://hd2.nfapp.southcn.com/nanfang_if/getColumns"
        : env === "test"
            ? "https://testapi.nfapp.southcn.com/nanfang_if/getColumns"
            // ? "https://testapi.nfapp.southcn.com/nanfang_if/getColumns"
            : "https://testapi.nfapp.southcn.com/nanfang_if/getColumns"

const request = axios.create({
    // baseURL: process.env.BASE_API, // api的base_url
    baseURL: BASE_API, // api的base_url
    timeout: 60000, // 请求超时时间
    // headers: {
    //     "Content-Type": "application/json"
    // },
    withCredentials: false
})
// request.interceptors.response.use((response) => {
//     if (response.status == 200) {
//         return response.data
//     }
//     return response
// })

export default request


// 栏目ID
export const ColumnIdTab =
    env === "production"
        ? 26398
        : env === "test"
            ? 12269
            : 12269
export const ColumnIdHome =
    env === "production"
        ? 31826
        : env === "test"
            ? 12270
            : 12270
export const ColumnIdArticle =
    env === "production"
        ? 31827
        : env === "test"
            ? 12271
            : 12271